import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "../styles/Ministry.module.css";
import { FaArrowRight } from "react-icons/fa";
import heroImg from "../assets/images/image12.png";
import img1 from "../assets/images/abarinzi.png";
import img2 from "../assets/images/image8.png";
import img3 from "../assets/images/usher.png";
import img4 from "../assets/images/media.png";
import img5 from "../assets/images/interpretation.png";
import img6 from "../assets/images/media.png";
import img7 from "../assets/images/image12.png";
import youthImg from "../assets/images/image7.png";
import womenImg from "../assets/images/MamaMiriam.png"; 
import menImg from "../assets/images/image1.png"; 
import getInvolvedBg from "../assets/images/image7.png"; 

const ministries = [
  {
    id: 1,
    title: "Intercession Team",
    desc: "Join our dedicated prayer warriors who intercede for the church, community, and world. Make a spiritual impact through fervent, focused prayer.",
    image: img1,
  },
  {
    id: 2,
    title: "Worship Team",
    desc: "Use your musical talents to lead worship and create an atmosphere of praise. Whether singing, playing instruments, or sound engineering.",
    image: img2,
  },
  {
    id: 3,
    title: "Ushers & Hospitality",
    desc: "Welcome visitors and members with warmth and excellence. Serve as the first impression of CWFM's hospitality and care.",
    image: img3,
  },
  {
    id: 4,
    title: "Media & Production",
    desc: "Manage live streaming, video production, graphics, and technical operations. Help us reach people through modern media platforms.",
    image: img4,
  },
  {
    id: 5,
    title: "Interpretation Department",
    desc: "Bridge language barriers and enable everyone to receive God's word. Provide real-time interpretation services during services and events.",
    image: img5,
  },
  {
    id: 6,
    title: "IT & Technology",
    desc: "Support our church's digital infrastructure, website, apps, and online systems. Keep our technology running smoothly and securely.",
    image: img6,
  },
  {
    id: 7,
    title: "Kids Ministry",
    desc: "Shape young lives through Bible teaching, fun activities, and mentorship. Create a safe, nurturing space for children to grow in faith.",
    image: img7,
  },
  {
    id: 8,
    title: "Youth Ministry",
    desc: "Engage and disciple teenagers and young adults through relevant Bible studies, fellowship events, and leadership development programs.",
    image: youthImg,
  },
  {
    id: 9,
    title: "Women's Ministry",
    desc: "Empower women of all ages through Bible studies, prayer groups, mentorship programs, and special events focused on spiritual growth.",
    image: womenImg,
  },
  {
    id: 10,
    title: "Men's Ministry",
    desc: "Equip men to be spiritual leaders through discipleship, accountability groups, service projects, and fellowship opportunities.",
    image: menImg,
  },
];

export default function Ministry() {
  const navigate = useNavigate();
  const [hoveredCard, setHoveredCard] = useState(null);

  const handleJoinUs = (e) => {
    e.preventDefault();
    // Navigate directly to membership form
    navigate("/membership");
  };

  return (
    <div className={styles.ministryPage}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <img src={heroImg} alt="Our Ministries" className={styles.heroImg} />
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>Our Ministries</h1>
          <p className={styles.heroDesc}>
            Discover the various ways we serve God and our community through
            faith, fellowship, and active service at Calvary Wide Fellowship Ministries.
          </p>
        </div>
      </section>

      {/* Ministries Section */}
      <section className={styles.section}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>Ways to Serve</h2>
          <p className={styles.sectionDesc}>
            There are so many ways to serve in our ministry! Whether you're passionate about prayer, worship, hospitality, technology, or working with specific age groups, 
            find your place to make a difference in God's kingdom.
          </p>
        </div>

        <div className={styles.ministryGrid}>
          {ministries.map((ministry) => (
            <div
              key={ministry.id}
              className={styles.ministryCard}
              onMouseEnter={() => setHoveredCard(ministry.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className={styles.cardImage}>
                <img
                  src={ministry.image}
                  alt={ministry.title}
                  className={styles.cardImg}
                />
              </div>
              <div className={styles.cardContent}>
                <h3 className={styles.cardTitle}>{ministry.title}</h3>
                <p className={styles.cardDesc}>{ministry.desc}</p>
                <a href="#" className={styles.cardLink}>
                  Learn More{" "}
                  <FaArrowRight className={styles.cardLinkIcon} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section with background image */}
      <section 
        className={styles.ctaSection}
        style={{ backgroundImage: `url(${getInvolvedBg})` }}
      >
        <div className={styles.ctaInner}>
          <h2 className={styles.ctaTitle}>Get Involved</h2>
          <p className={styles.ctaDesc}>
            Ready to serve and grow with us? Connect with a ministry team that
            aligns with your passions and spiritual gifts. We'd love to have you
            join our community of dedicated believers!
          </p>
          <a 
            href="/membership" 
            className={styles.ctaButton}
            onClick={handleJoinUs}
          >
            Join Us
          </a>
        </div>
      </section>
    </div>
  );
}